import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams } from 'react-router-dom';
const ItemTransactionReport = () => {
  // fin-year start is stored as dd/MM/yyyy; <input type="date"> needs yyyy-MM-dd
  const finStartMatch = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/.exec(
    localStorage.getItem("financeyearstartdate") || ""
  );
  const defaultFrom = finStartMatch
    ? `${finStartMatch[3]}-${finStartMatch[2].padStart(2, "0")}-${finStartMatch[1].padStart(2, "0")}`
    : "2014-04-01";

  const [fromDate, setFromDate] = useState(defaultFrom);
  const [toDate, setToDate] = useState(new Date().toLocaleDateString("en-CA"));
  const [voucherType, setVoucherType] = useState("");
  const [particular, setParticular] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
 const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const branchParam =
    searchParams.get("branch") || localStorage.getItem("branchId") || "";
  console.log("id:",id);
  const fetchReport = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://nissi-india.com/api/item_transactionRpt`,
        {
          headers: {
            "x-finyearid": localStorage.getItem("finYearId") || "",
            "x-finyear": localStorage.getItem("finYear") || "",
            "x-branchid": localStorage.getItem("branchId") || "",
            "x-branch": localStorage.getItem("branchType") || "",
            "x-userid": localStorage.getItem("userId") || "",
          },
          params: {
            item: id,
            branch: branchParam,
                        store: "%",
            vouType: voucherType || "%",
            from: fromDate.split("-").reverse().join("/"),
            to: toDate.split("-").reverse().join("/"),
            particular: particular || "%"
          }
        }
      );
      setReportData(response.data.data || []);
      console.log("response:", response.data);
    } catch (err) {
      console.error("Error fetching report:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // "2026-09-11T00:00:00.000Z" -> "11/09/2026"
  // Uses the date part of the string as-is (no new Date()), so the browser
  // timezone can never shift the day.
  const formatDate = (value) => {
    if (!value) return "";
    const [y, m, d] = String(value).slice(0, 10).split("-");
    return y && m && d ? `${d}/${m}/${y}` : String(value);
  };

  return (
    <div className="p-6">
      {/* Filters */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        <div>
          <label className="block text-sm font-medium">From Date *</label>
          <input
            type="date"
            className="border p-2 rounded w-full"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium">To Date *</label>
          <input
            type="date"
            className="border p-2 rounded w-full"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Voucher Type</label>
          <select
            className="border p-2 rounded w-full"
            value={voucherType}
            onChange={(e) => setVoucherType(e.target.value)}
          >
                       <option value="">Select</option>
            <option value="OP">Opening</option>
            <option value="GRN">GRN</option>
            <option value="STNI">STN Inward</option>
            <option value="STNO">STN Outward</option>
            <option value="SI">Store Issue</option>
            <option value="SR">SR</option>
            <option value="SCR">SCR</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium">Particulars</label>
          <input
            type="text"
            className="border p-2 rounded w-full"
            value={particular}
            onChange={(e) => setParticular(e.target.value)}
          />
        </div>
      </div>

      <button
        className="bg-blue-600 text-white px-4 py-2 rounded mb-6"
        onClick={fetchReport}
      >
        View
      </button>

      {/* Report Table */}
      <div className="border rounded shadow overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-2 py-1">SNo</th>
              <th className="border px-2 py-1">Date</th>
              <th className="border px-2 py-1">Ref Number</th>
              <th className="border px-2 py-1">Particulars</th>
              <th className="border px-2 py-1">Voucher Type</th>
              <th className="border px-2 py-1">Inward Qty</th>
              <th className="border px-2 py-1">Inward Value</th>
              <th className="border px-2 py-1">Outward Qty</th>
              <th className="border px-2 py-1">Outward Value</th>
              <th className="border px-2 py-1">Closing Qty</th>
              <th className="border px-2 py-1">Total Amount</th>
              <th className="border px-2 py-1">Closing Value</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="12" className="text-center p-4">
                  Loading...
                </td>
              </tr>
            ) : reportData.length > 0 ? (
              reportData.map((row, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="border px-2 py-1">{idx + 1}</td>
                  <td className="border px-2 py-1">{formatDate(row.fld_DocumentDate)}</td>
                                    <td className="border px-2 py-1">{row.Reference}</td>
                  <td className="border px-2 py-1">{row.Particulars}</td>
                  <td className="border px-2 py-1">{row.fld_documenttype}</td>
                  <td className="border px-2 py-1">{row.Received}</td>
                  <td className="border px-2 py-1">{row.ReceivedPrice}</td>
                  <td className="border px-2 py-1">{row.Issued}</td>
                  <td className="border px-2 py-1">{row.IssuePrice}</td>
                  <td className="border px-2 py-1">{row.fld_Closing_stock}</td>
                  <td className="border px-2 py-1">{row.totalclosingamount}</td>
                  <td className="border px-2 py-1">{row.ClosingValue}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="text-center p-4">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ItemTransactionReport;
